import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { useState } from 'react'
import { Button } from './Button'
import * as motion from 'motion/react-client'

export function Modal({
    triggerText = 'Open dialog',
    title,
    children,
    confirmText = 'Got it, thanks!',
    panelClassName = '',
    triggerVariant = 'primary',
    confirmVariant = 'primary',
    triggerSize = 'medium',
    confirmSize = 'medium',
}) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className='bg-red-100'>
            <Button variant={triggerVariant} size={triggerSize} onClick={() => setIsOpen(true)}>
                {triggerText}
            </Button>

            <Dialog open={isOpen} onClose={() => setIsOpen(false)} className='relative z-10'>
                <div className='fixed inset-0 bg-black/30' aria-hidden='true' />
                <div className='fixed inset-0 flex items-center justify-center p-4'>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                    >
                        <DialogPanel
                            className={`w-full max-w-md rounded-xl bg-white p-6 shadow-xl ${panelClassName}`}
                        >
                            <DialogTitle className='text-lg font-medium text-gray-900'>
                                {title}
                            </DialogTitle>
                            <div className='mt-4 text-sm text-gray-600'>{children}</div>
                            <div className='flex justify-end mt-6'>
                                <Button
                                    variant={confirmVariant}
                                    size={confirmSize}
                                    onClick={() => setIsOpen(false)}
                                >
                                    {confirmText}
                                </Button>
                            </div>
                        </DialogPanel>
                    </motion.div>
                </div>
            </Dialog>
        </div>
    )
}
